import { lookupService } from "@/services/api/lookup.service";
import i18n from "@/i18n";
import { sharedHelper, alertHelper } from "@/utils";
import { lookupModel } from "@/models/api/lookup.model";

export const state = {
  countryDdl: [],
  stateDdl: [],
  locationDdl: [],
  articleCategoryDdl: [],
  articleTypeDdl: [],
  companyDdl: [],
  companyTypeDdl: [],
  groupDdl: [],
  officeTypeDdl: [],
  positionDdl: [],
  companyDepartmentOfficeDdl: [],
  notificationChannelDdl: [],
  notificationIconDdl: [],
  documentCategoryDdl: [],
  catalogSubcategoryDdl: [],
  catalogCategoryDdl: [],
  userDdl: [],
  userEmailDdl: [],
  propertyAssetDdl: [],
  propertyActionDdl: [],
  propertyAreaUnitDdl: [],
  propertyCategoryDdl: [],
  propertyStatusDdl: [],
  propertyTenureDdl: [],
  propertyTypeDdl: [],
  officeDdl: [],
  amenityDdl: [],
  meetingRoomDdl: [],
  departmentDdl: [],
  candidateJobDdl: [],
  candidateStatusDdl: [],
  panelTypeDdl: [],
  workgroupDdl: [],
  orientationModuleHeaderDdl: [],
};

export const LOOKUP_MODULE = "api/lookup";

// ACTIONS
export const LOOKUP_COUNTRY = "lookupCountry";
export const LOOKUP_STATE = "lookupState";
export const LOOKUP_LOCATION = "lookupLocation";
export const LOOKUP_ARTICLE_CATEGORY = "lookupArticleCategory";
export const LOOKUP_ARTICLE_TYPE = "lookupArticleType";
export const LOOKUP_COMPANY = "lookupCompany";
export const LOOKUP_COMPANY_TYPE = "lookupCompanyType";
export const LOOKUP_GROUP = "lookupGroup";
export const LOOKUP_OFFICE_TYPE = "lookupOfficeType";
export const LOOKUP_POSITION = "lookupPosition";
export const LOOKUP_COMPANY_DEPARTMENT_OFFICE = "lookupCompanyDepartmentOffice";
export const LOOKUP_NOTIFICATION_CHANNEL = "lookupNotificationChannel";
export const LOOKUP_NOTIFICATION_ICON = "lookupNotificationIcon";
export const LOOKUP_DOCUMENT_CATEGORY = "lookupDocumentCategory";
export const LOOKUP_CATALOG_SUBCATEGORY = "lookupCatalogSubcategory";
export const LOOKUP_CATALOG_CATEGORY = "lookupCatalogCategory";
export const LOOKUP_USER = "lookupUser";
export const LOOKUP_USER_EMAIL = 'lookupUserEmail';
export const LOOKUP_PROPERTY_ASSET = "lookupPropertyAsset";
export const LOOKUP_PROPERTY_ACTION = "lookupPropertyAction";
export const LOOKUP_PROPERTY_AREA_UNIT = "lookupPropertyAreaUnit";
export const LOOKUP_PROPERTY_CATEGORY = "lookupPropertyCategory";
export const LOOKUP_PROPERTY_STATUS = "lookupPropertyStatus";
export const LOOKUP_PROPERTY_TENURE = "lookupPropertyTenure";
export const LOOKUP_PROPERTY_TYPE = "lookupPropertyType";
export const LOOKUP_OFFICE = "lookupOffice";
export const LOOKUP_AMENITY = "lookupAmenity";
export const LOOKUP_MEETING_ROOM = "lookupMeetingRoom";
export const LOOKUP_DEPARTMENT = "lookupDepartment";
export const LOOKUP_CANDIDATE_JOB = "lookupCandidateJob";
export const LOOKUP_CANDIDATE_STATUS = "lookupCandidateStatus";
export const LOOKUP_PANEL_TYPE = "lookupPanelType";
export const LOOKUP_WORKGROUP = "lookupWorkgroup";
export const LOOKUP_ORIENTATION_MODULE_HEADER = "lookupOrientationModuleHeader";

// MUTATIONS
const COUNTRY_LOOKUP = "countryLookup";
const STATE_LOOKUP = "stateLookup";
const LOCATION_LOOKUP = "locationLookup";
const ARTICLE_CATEGORY_LOOKUP = "articleCategoryLookup";
const ARTICLE_TYPE_LOOKUP = "articleTypeLookup";
const COMPANY_LOOKUP = "companyLookup";
const COMPANY_TYPE_LOOKUP = "companyTypeLookup";
const GROUP_LOOKUP = "groupLookup";
const OFFICE_TYPE_LOOKUP = "officeTypeLookup";
const POSITION_LOOKUP = "positionLookup";
const COMPANY_DEPARTMENT_OFFICE_LOOKUP = "companyDepartmentOfficeLookup";
const NOTIFICATION_CHANNEL_LOOKUP = "notificationChannelLookup";
const NOTIFICATION_ICON_LOOKUP = "notificationIconLookup";
const DOCUMENT_CATEGORY_LOOKUP = "documentCategoryLookup";
const CATALOG_SUBCATEGORY_LOOKUP = "catalogSubcategoryLookup";
const CATALOG_CATEGORY_LOOKUP = "catalogCategoryLookup";
const USER_LOOKUP = "userLookup";
const USER_EMAIL_LOOKUP = 'userEmailLookup';
const PROPERTY_ASSET_LOOKUP = "propertyAssetLookup";
const PROPERTY_ACTION_LOOKUP = "propertyActionLookup";
const PROPERTY_AREA_UNIT_LOOKUP = "propertyAreaUnitLookup";
const PROPERTY_CATEGORY_LOOKUP = "propertyCategoryLookup";
const PROPERTY_STATUS_LOOKUP = "propertyStatusLookup";
const PROPERTY_TENURE_LOOKUP = "propertyTenureLookup";
const PROPERTY_TYPE_LOOKUP = "propertyTypeLookup";
const OFFICE_LOOKUP = "officeLookup";
const AMENITY_LOOKUP = "amenityLookup";
const MEETING_ROOM_LOOKUP = "meetingRoomLookup";
const DEPARTMENT_LOOKUP = "departmentLookup";
const CANDIDATE_JOB_LOOKUP = "candidateJobLookup";
const CANDIDATE_STATUS_LOOKUP = "candidateStatusLookup";
const PANEL_TYPE_LOOKUP = "panelTypeLookup";
const WORKGROUP_LOOKUP = "workgroupLookup";
const ORIENTATION_MODULE_HEADER_LOOKUP = "orientationModuleHeaderLookup";

function lookupItems(result) {
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result?.data?.data)) return result.data.data;
  return [];
}

export const actions = {
  [LOOKUP_COUNTRY]({ commit }) {
    lookupService
      .getCountries()
      .then((result) => {
        commit(COUNTRY_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_STATE]({ commit }) {
    lookupService
      .getStates()
      .then((result) => {
        commit(STATE_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_LOCATION]({ commit }) {
    lookupService
      .getLocations()
      .then((result) => {
        commit(LOCATION_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_ARTICLE_CATEGORY]({ commit }, searchWords = []) {
    return lookupService
      .getArticleCategories(searchWords)
      .then((result) => {
        commit(ARTICLE_CATEGORY_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_ARTICLE_TYPE]({ commit }) {
    return lookupService
      .getArticleTypes()
      .then((result) => {
        commit(ARTICLE_TYPE_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_COMPANY]({ commit }, searchWords = []) {
    return lookupService
      .getCompanies(searchWords)
      .then((result) => {
        commit(COMPANY_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_COMPANY_TYPE]({ commit }) {
    return lookupService
      .getCompanyTypes()
      .then((result) => {
        commit(COMPANY_TYPE_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_GROUP]({ commit }) {
    return lookupService
      .getGroups()
      .then((result) => {
        commit(GROUP_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_OFFICE_TYPE]({ commit }) {
    return lookupService
      .getOfficeTypes()
      .then((result) => {
        commit(OFFICE_TYPE_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_NOTIFICATION_CHANNEL]({ commit }) {
    return lookupService
      .getNotificationChannels()
      .then((result) => {
        commit(NOTIFICATION_CHANNEL_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_POSITION]({ commit }) {
    return lookupService.getPositions().then((result) => {
      commit(POSITION_LOOKUP, { result });
    });
  },
  [LOOKUP_NOTIFICATION_ICON]({ commit }) {
    return lookupService
      .getNotificationIcons()
      .then((result) => {
        commit(NOTIFICATION_ICON_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_COMPANY_DEPARTMENT_OFFICE]({ commit }) {
    return lookupService.getCompanyDepartmentOffices().then((result) => {
      commit(COMPANY_DEPARTMENT_OFFICE_LOOKUP, { result });
    });
  },
  [LOOKUP_DOCUMENT_CATEGORY]({ commit }, searchWords = []) {
    return lookupService
      .getDocumentCategories(searchWords)
      .then((result) => {
        commit(DOCUMENT_CATEGORY_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_CATALOG_SUBCATEGORY]({ commit }, searchWords = []) {
    return lookupService
      .getCatalogSubcategories(searchWords)
      .then((result) => {
        commit(CATALOG_SUBCATEGORY_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_CATALOG_CATEGORY]({ commit }, searchWords = []) {
    return lookupService
      .getCatalogCategories(searchWords)
      .then((result) => {
        commit(CATALOG_CATEGORY_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_USER]({ commit }, filter = {}) {
    return lookupService
      .getUsers(filter)
      .then((result) => {
        commit(USER_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_USER_EMAIL]({ commit }, searchWords = []) {
    return lookupService
      .getUserEmails(searchWords)
      .then((result) => {
        commit(USER_EMAIL_LOOKUP, {result});
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_PROPERTY_ASSET]({ commit }) {
    return lookupService
      .getPropertyAssets()
      .then((result) => {
        commit(PROPERTY_ASSET_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_PROPERTY_ACTION]({ commit }) {
    lookupService
      .getPropertyActions()
      .then((result) => {
        commit(PROPERTY_ACTION_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_PROPERTY_AREA_UNIT]({ commit }) {
    return lookupService
      .getPropertyAreaUnits()
      .then((result) => {
        commit(PROPERTY_AREA_UNIT_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_PROPERTY_CATEGORY]({ commit }) {
    lookupService
      .getPropertyCategories()
      .then((result) => {
        commit(PROPERTY_CATEGORY_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_PROPERTY_STATUS]({ commit }) {
    lookupService
      .getPropertyStatuses()
      .then((result) => {
        commit(PROPERTY_STATUS_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_PROPERTY_TENURE]({ commit }) {
    lookupService
      .getPropertyTenures()
      .then((result) => {
        commit(PROPERTY_TENURE_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_PROPERTY_TYPE]({ commit }) {
    lookupService
      .getPropertyTypes()
      .then((result) => {
        commit(PROPERTY_TYPE_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_OFFICE]({ commit }, filter = {}) {
    return lookupService
      .getOffices(filter)
      .then((result) => {
        commit(OFFICE_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_AMENITY]({ commit }, searchWords = []) {
    return lookupService
      .getAmenities(searchWords)
      .then((result) => {
        commit(AMENITY_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_MEETING_ROOM]({ commit }, filter = {}) {
    return lookupService
      .getMeetingRooms(filter)
      .then((result) => {
        commit(MEETING_ROOM_LOOKUP, { result });
        return result;
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
        return null;
      });
  },
  [LOOKUP_DEPARTMENT]({ commit }) {
    lookupService
      .getDepartments()
      .then((result) => {
        commit(DEPARTMENT_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_CANDIDATE_JOB]({ commit }) {
    lookupService
      .getCandidateJobs()
      .then((result) => {
        commit(CANDIDATE_JOB_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_CANDIDATE_STATUS]({ commit }) {
    lookupService
      .getCandidateStatuses()
      .then((result) => {
        commit(CANDIDATE_STATUS_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
  [LOOKUP_PANEL_TYPE]({ commit }) {
    lookupService
      .getPanelTypes()
      .then((result) => {
        commit(PANEL_TYPE_LOOKUP, { result });
      })
      .catch((error) => {
        alertHelper.alertError({
          message: sharedHelper.getErrorMessage(error),
          title: i18n.t("message.error"),
        });
      });
  },
};

export const mutations = {
  [COUNTRY_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.countryDdl = array;
    } else {
      state.countryDdl = [];
    }
  },
  [STATE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.stateDdl = array;
    } else {
      state.stateDdl = [];
    }
  },
  [LOCATION_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.locationDdl = array;
    } else {
      state.locationDdl = [];
    }
  },
  [COMPANY_LOOKUP](state, { result }) {
    state.companyDdl =
      result?.success === false ? [] : lookupItems(result).map(lookupModel);
  },
  [COMPANY_TYPE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.companyTypeDdl = array;
    } else {
      state.companyTypeDdl = [];
    }
  },
  [GROUP_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.groupDdl = array;
    } else {
      state.groupDdl = [];
    }
  },
  [OFFICE_TYPE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.officeTypeDdl = array;
    } else {
      state.officeTypeDdl = [];
    }
  },
  [POSITION_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.positionDdl = array;
    } else {
      state.positionDdl = [];
    }
  },
  [COMPANY_DEPARTMENT_OFFICE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push({
          ...lookupModel(item),
          departments: (item.departments ?? []).map((department) =>
            lookupModel(department),
          ),
          offices: (item.offices ?? []).map((office) => lookupModel(office)),
        });
      });
      state.companyDepartmentOfficeDdl = array;
    } else {
      state.companyDepartmentOfficeDdl = [];
    }
  },
  [ARTICLE_CATEGORY_LOOKUP](state, { result }) {
    state.articleCategoryDdl = lookupItems(result).map(lookupModel);
  },
  [ARTICLE_TYPE_LOOKUP](state, { result }) {
    state.articleTypeDdl = lookupItems(result).map(lookupModel);
  },
  [NOTIFICATION_CHANNEL_LOOKUP](state, { result }) {
    state.notificationChannelDdl = lookupItems(result).map(lookupModel);
  },
  [NOTIFICATION_ICON_LOOKUP](state, { result }) {
    state.notificationIconDdl = lookupItems(result).map(lookupModel);
  },
  [DOCUMENT_CATEGORY_LOOKUP](state, { result }) {
    state.documentCategoryDdl = lookupItems(result).map(lookupModel);
  },
  [CATALOG_SUBCATEGORY_LOOKUP](state, { result }) {
    state.catalogSubcategoryDdl = lookupItems(result).map(lookupModel);
  },
  [CATALOG_CATEGORY_LOOKUP](state, { result }) {
    state.catalogCategoryDdl = lookupItems(result).map(lookupModel);
  },
  [USER_LOOKUP](state, { result }) {
    state.userDdl = lookupItems(result).map(lookupModel);
  },
  [USER_EMAIL_LOOKUP](state, { result }) {
      state.userEmailDdl = lookupItems(result).map(lookupModel);
  },
  [PROPERTY_ASSET_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyAssetDdl = array;
    } else {
      state.propertyAssetDdl = [];
    }
  },
  [PROPERTY_ACTION_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyActionDdl = array;
    } else {
      state.propertyActionDdl = [];
    }
  },
  [PROPERTY_AREA_UNIT_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyAreaUnitDdl = array;
    } else {
      state.propertyAreaUnitDdl = [];
    }
  },
  [PROPERTY_CATEGORY_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyCategoryDdl = array;
    } else {
      state.propertyCategoryDdl = [];
    }
  },
  [PROPERTY_STATUS_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyStatusDdl = array;
    } else {
      state.propertyStatusDdl = [];
    }
  },
  [PROPERTY_TENURE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyTenureDdl = array;
    } else {
      state.propertyTenureDdl = [];
    }
  },
  [PROPERTY_TYPE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.propertyTypeDdl = array;
    } else {
      state.propertyTypeDdl = [];
    }
  },
  [OFFICE_LOOKUP](state, { result }) {
    state.officeDdl = lookupItems(result).map(lookupModel);
  },
  [AMENITY_LOOKUP](state, { result }) {
    state.amenityDdl = lookupItems(result).map(lookupModel);
  },
  [MEETING_ROOM_LOOKUP](state, { result }) {
    state.meetingRoomDdl = lookupItems(result).map(lookupModel);
  },
  [DEPARTMENT_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.departmentDdl = array;
    } else {
      state.departmentDdl = [];
    }
  },
  [CANDIDATE_JOB_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.candidateJobDdl = array;
    } else {
      state.candidateJobDdl = [];
    }
  },
  [CANDIDATE_STATUS_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.candidateStatusDdl = array;
    } else {
      state.candidateStatusDdl = [];
    }
  },
  [PANEL_TYPE_LOOKUP](state, { result }) {
    let array = [];
    if (result.success) {
      result.data.forEach((item) => {
        array.push(lookupModel(item));
      });
      state.panelTypeDdl = array;
    } else {
      state.panelTypeDdl = [];
    }
  },
  [WORKGROUP_LOOKUP](state, { result }) {
      let array = [];
      if (result.success) {
          result.data.forEach((item) => {
              array.push(lookupModel(item));
          })
          state.workgroupDdl = array;
      } else {
          state.workgroupDdl = [];
      }
  },
  [ORIENTATION_MODULE_HEADER_LOOKUP](state, { result }) {
      let array = [];
      if (result.success) {
          result.data.forEach((item) => {
              array.push(lookupModel(item));
          })
          state.orientationModuleHeaderDdl = array;
      } else {
          state.orientationModuleHeaderDdl = [];
      }
  },
};
